module.exports = __webpack_public_path__ + "img/about-7.56247bfa.png";